var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-layout',[_c('a-layout-header',{staticClass:"headBar"},[_c('a-row',[_c('a-col',{attrs:{"span":6}},[_c('img',{staticStyle:{"margin-left":"30px"},attrs:{"src":_vm.base_url() + '/static/img/banner.png',"width":"250"},on:{"click":_vm.goTo}})]),_vm._v(" "),_c('a-col',{attrs:{"span":6}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d5aca07","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 972
// module chunks = 2 13 14